import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _COLUMN_FIELDS;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import computeInsertPosition from '../../utils/computeInsertPosition';
import getDefaultPosition from '../../utils/getDefaultPosition';
import ColumnTypes from '../../types/ColumnTypes';
import FieldTypes from '../../types/FieldTypes';
var DEFAULT_COLUMN_NAME = 'Column';
var COLUMN_FIELDS = (_COLUMN_FIELDS = {}, _defineProperty(_COLUMN_FIELDS, ColumnTypes.NAME, FieldTypes.TEXT), _defineProperty(_COLUMN_FIELDS, ColumnTypes.TEXT, FieldTypes.TEXT), _defineProperty(_COLUMN_FIELDS, ColumnTypes.RICH_TEXT, FieldTypes.TEXT), _defineProperty(_COLUMN_FIELDS, ColumnTypes.NUMBER, FieldTypes.TEXT), _defineProperty(_COLUMN_FIELDS, ColumnTypes.TODO, FieldTypes.CHECKED), _defineProperty(_COLUMN_FIELDS, ColumnTypes.DATE, FieldTypes.TEXT), _defineProperty(_COLUMN_FIELDS, ColumnTypes.USER, FieldTypes.USERS), _defineProperty(_COLUMN_FIELDS, ColumnTypes.SELECT, FieldTypes.OPTIONS), _defineProperty(_COLUMN_FIELDS, ColumnTypes.MULTI_SELECT, FieldTypes.OPTIONS), _defineProperty(_COLUMN_FIELDS, ColumnTypes.USERS, FieldTypes.USERS), _defineProperty(_COLUMN_FIELDS, ColumnTypes.NOTES, FieldTypes.NOTES), _COLUMN_FIELDS);

function getColumns(database) {
  return database.value.columns;
}

function getColumn(database, columnKey) {
  return database.value.columns[columnKey];
}

function getColumnsCount(database) {
  return Object.keys(database.value.columns).length;
}

function getSortedColumns(database) {
  return Object.values(database.value.columns).sort(function (a, b) {
    return a.position - b.position;
  });
}

function getFirstColumn(database) {
  return database.getSortedColumns()[0];
}

function getLastColumn(database) {
  return database.getSortedColumns()[database.getColumnsCount() - 1];
}

function isColumnEmpty(database, columnKey) {
  var column = database.getColumn(columnKey);
  return !Object.values(database.getRecords()).some(function (record) {
    return record.fields[columnKey] && record.fields[columnKey].data[COLUMN_FIELDS[column.type]] !== undefined;
  });
}

function insertColumn(database) {
  var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var lastColumn = getLastColumn(database);
  return database.applyAction({
    type: 'insertColumn',
    payload: {
      attrs: _objectSpread({
        position: getDefaultPosition(lastColumn ? lastColumn.position : 0)
      }, attrs),
      currentUserId: database.currentUserId
    }
  });
}

function setColumn(database, key, attrs) {
  return database.applyAction({
    type: 'setColumn',
    payload: {
      key: key,
      attrs: attrs,
      currentUserId: database.currentUserId
    }
  });
}

function changeColumnType(database, key, type) {
  var attrs = {
    type: type
  }; // Update column with type if it has not changed

  var column = database.getColumn(key);
  var previousRenderType = database.run('renderColumnType', column.type);
  var nextRenderType = database.run('renderColumnType', type);

  if (column.name === DEFAULT_COLUMN_NAME || column.name === previousRenderType) {
    attrs.name = nextRenderType;
  }

  var activeSort = database.getActiveSort(key);

  if (activeSort && activeSort.columnKey === key) {
    database.removeSort(key);
  }

  return database.setColumn(key, attrs);
}

function getColumnBefore(database, columnKey) {
  var sortedColumns = database.getSortedColumns();
  var currentIndex = sortedColumns.findIndex(function (_ref) {
    var key = _ref.key;
    return key === columnKey;
  });
  return sortedColumns[currentIndex - 1];
}

function getColumnAfter(database, columnKey) {
  var sortedColumns = database.getSortedColumns();
  var currentIndex = sortedColumns.findIndex(function (_ref2) {
    var key = _ref2.key;
    return key === columnKey;
  });
  return sortedColumns[currentIndex + 1];
}

function insertColumnBefore(database, columnKey) {
  var attrs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  database.insertColumn(_objectSpread({}, attrs, {
    position: computeInsertPosition(database.getSortedColumns(), database.value.columns[columnKey], 'before')
  }));
}

function insertColumnAfter(database, columnKey) {
  var attrs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  database.insertColumn(_objectSpread({}, attrs, {
    position: computeInsertPosition(database.getSortedColumns(), database.value.columns[columnKey], 'after')
  }));
}

function deleteColumn(database, columnKey) {
  return database.applyAction({
    type: 'deleteColumn',
    payload: {
      columnKey: columnKey
    }
  });
}

export default {
  commands: {
    insertColumn: insertColumn,
    insertColumnBefore: insertColumnBefore,
    insertColumnAfter: insertColumnAfter,
    setColumn: setColumn,
    deleteColumn: deleteColumn,
    changeColumnType: changeColumnType
  },
  queries: {
    getColumns: getColumns,
    getColumn: getColumn,
    getFirstColumn: getFirstColumn,
    getLastColumn: getLastColumn,
    getSortedColumns: getSortedColumns,
    getColumnsCount: getColumnsCount,
    getColumnBefore: getColumnBefore,
    getColumnAfter: getColumnAfter,
    isColumnEmpty: isColumnEmpty
  }
};